import $ from 'jquery';
import BasePropertyView from 'BasePropertyView.js';
import contentTemplate from 'properties/style/slider-scale.ejs';
import { pickerCfg } from 'pickerCfg.js';
import util from 'util/Util.js';

class StyleSliderScaleView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);
        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.events = {
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus',
            'change input[type=color]': 'updateColorAttributes',            
            'change #tickColor' : 'updateColorAttributesWithValidation', 
            'change select': 'updateSelectAttributes',
            'blur select': 'updateSelectAttributes'
        };

        return this;
    }

    updateSelectAttributes(ev) {
        const propName = ev.currentTarget.name;
        let propVal = ev.currentTarget.value;

        var stepLength = propVal = parseInt(propVal);
        const max = parseInt(this.model.get('maxValue'));
        const min = parseInt(this.model.get('minValue'));
        var scaleLength = parseInt(max) - parseInt(min);
        var unitDistance = 100 / scaleLength;
        var finalDistance = unitDistance * stepLength;
        var steps = scaleLength / stepLength;
        this.model.set('steps', steps);
        this.model.set('distance', finalDistance);

        this.model.set(propName, propVal);
    }

    render() {
        super.render();

        this.$el.html(this.template(this.model.toJSON()));

        //.$('input[type=color]', this.$el).spectrum(pickerCfg);

        $('#tickInterval').find('option[value='
            + this.model.get('tickInterval')
            + ']').attr('selected', true);

        this.delegateEvents();

        return this;
    }
}

export default StyleSliderScaleView;